
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB
export const MAX_FILES_PER_UPLOAD = 10;
export const ALLOWED_EXTENSIONS = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "docx",
  "xlsx",
  "pptx",
  "txt",
  "csv",
  "zip",
];

export const ACCEPT_ATTRIBUTE = ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",");

export function getExtension(fileName) {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
}

// Devuelve el motivo de rechazo, o null si el archivo es válido
export function validateFile(file) {
  if (!ALLOWED_EXTENSIONS.includes(getExtension(file.name))) {
    return "File type not allowed";
  }
  if (file.size > MAX_FILE_SIZE) {
    return "File exceeds 25 MB";
  }
  if (file.size === 0) {
    return "File is empty";
  }
  return null;
}

export function formatSize(size) {
  if (size < 1024) return size + " bytes";
  else if (size < 1048576) return (size / 1024).toFixed(2) + " KB";
  else return (size / 1048576).toFixed(2) + " MB";
}
